/* global _  angular */
import './style.less';
import blank100 from './blank100.json';
import blankInOut100 from './blankInOut100.json';
import blankSS100 from './blankSS100.json';
import pdfMake from 'pdfmake/build/pdfmake.min.js';
import { pdfMake as vfsObject } from 'pdfmake/build/vfs_fonts.js';

pdfMake.vfs = vfsObject.vfs;

export default function($log, $filter) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  let sponsorLogoUrl = false;

  function getDate(date, timeZoneId) {
    if (!date) return false;
    return $filter('PrettyDateTime')(date, timeZoneId);
  }

  function buildInstructorList(instructors = []) {
    return instructors.map(({ first, last }) => `${first} ${last}`);
  }

  function buildHourList(hours = []) {
    return hours.map(({ credits, subject_area }) => `${subject_area} - ${credits} Hour(s)`);
  }

  function buildRegistrants(registrants = [], blank, type = false) {
    if (blank && type === 'inOut') return blankInOut100;
    if (blank && type === 'signInOut') return blankSS100;
    if (blank) return blank100;

    registrants = _.sortBy(registrants, 'last');
    return registrants.map(({ email, first, last }) => {
      const params = [
        { text: `${first} ${last}` },
        { text: email, fillColor: '#eeeeee', style: 'tableContent' },
        {},
        {}
      ];

      if (type === 'inOut') {
        params.push({});
      }

      if (type === 'signInOut') {
        params.push({});
        params.push({});
      }

      return params;
    });
  }

  function buildInstructors(instructors = [], blank, type = false) {
    if (blank) return [];

    instructors = _.sortBy(instructors, 'first');
    return instructors.map(({ email, first, last }) => {
      const params = [
        { text: `${first} ${last}` },
        { text: email, fillColor: '#eeeeee', style: 'tableContent' },
        {},
        {},
        {},
        {}
      ];

      if (type === 'inOut') {
        params.push({});
      }

      if (type === 'signInOut') {
        params.push({});
        params.push({});
      }

      return params;
    });
  }

  function urlToDataUrl(url) {
    return new Promise(resolve => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function() {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  function sponsorLogo() {
    if (!sponsorLogoUrl) return {};
    return {
      alignment: 'right',
      image: sponsorLogoUrl,
      fit: [200, 75]
    };
  }

  function simpleSignInSheetDoc(event, registrants, blank) {
    return {
      pageSize: 'LETTER',
      pageOrientation: 'landscape',
      pageMargins: [10, 30, 10, 40],
      footer: (currentPage, pageCount) => {
        return {
          margin: [20, 0, 20, 0],
          layout: 'noBorders',
          table: {
            widths: ['auto', 'auto', '*', 'auto'],
            body: [
              [
                { text: `Program Title:\n${event.course_name}`, fontSize: 8 },
                { text: `Date:\n${getDate(event.delivery_date, vm.location.timeZoneId)}`, fontSize: 8 },
                { text: `Location:\n${vm.location.location || 'Remote'}`, fontSize: 8 },
                { alignment: 'right', text: `Page ${currentPage} of ${pageCount}`, fontSize: 8 }
              ]
            ]
          }
        };
      },
      content: [
        {
          margin: [30, 20, 30, 0],
          stack: [
            {
              columns: [
                {
                  stack: [
                    { text: `Program Title: ${event.course_name}` },
                    { text: `Location: ${vm.location.location || 'Remote'}` },
                    { text: `Start Date: ${getDate(event.delivery_date, vm.location.timeZoneId) || 'NA'}` },
                    { text: `End Date: ${getDate(event.delivery_end_date, vm.location.timeZoneId) || 'NA'}` }
                  ]
                },
                sponsorLogo()
              ]
            }
          ]
        },
        {
          margin: [30, 10, 30, 0],
          stack: [
            {
              columns: [
                { stack: [{ text: 'Instructor(s):' }, { ul: buildInstructorList(event.instructors) }] },
                { stack: [{ text: 'Recommended CPE Credit(s):' }, { ul: buildHourList(event.hours) }] }
              ]
            }
          ]
        },
        {
          margin: [40, 10, 40, 0],
          fontSize: 9,
          text:
            '*To allow for proper CPE credit calculation, please note time of late arrival, early departure, and/or any time missing from the classroom per day (start and end time) in the Instructor Exception Details column.',
          alignment: 'center'
        },
        {
          pageBreak: 'after',
          margin: [20, 20, 20, 0],
          table: {
            dontBreakRows: true,
            widths: [140, 165, 50, 40, 130, '*'],
            headerRows: 2,
            height: 12,
            body: [
              [
                { text: 'Name', style: 'tableHeader' },
                {
                  stack: [
                    { text: 'Email', style: 'tableHeader' },
                    { text: '( Where certificates will be sent )', style: 'thirdHeader' }
                  ],
                  fillColor: '#eeeeee'
                },
                {
                  stack: [
                    { text: 'Taught Before?', style: 'secondaryHeader' },
                    { text: '( Y / N )', style: 'thirdHeader' }
                  ]
                },
                {
                  stack: [{ text: 'Prep', style: 'tableHeader' }, { text: '( Minutes )', style: 'thirdHeader' }]
                },
                { text: 'Signature', style: 'tableHeader' },
                { text: 'Instructor Exception Details *', style: 'tableHeader' }
              ],
              [{ text: 'Instructors', bold: true, colSpan: 6, fillColor: '#eeeeee' }, {}, {}, {}, {}, {}],
              ...buildInstructors(event.instructors, blank),
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}]
            ]
          }
        },
        {
          margin: [30, 20, 30, 0],
          stack: [
            {
              columns: [
                {
                  stack: [
                    { text: `Program Title: ${event.course_name}` },
                    { text: `Location: ${vm.location.location || 'Remote'}` },
                    { text: `Start Date: ${getDate(event.delivery_date, vm.location.timeZoneId) || 'NA'}` },
                    { text: `End Date: ${getDate(event.delivery_end_date, vm.location.timeZoneId) || 'NA'}` }
                  ]
                },
                sponsorLogo()
              ]
            }
          ]
        },
        {
          margin: [30, 10, 30, 0],
          stack: [
            {
              columns: [
                { stack: [{ text: 'Instructor(s):' }, { ul: buildInstructorList(event.instructors) }] },
                { stack: [{ text: 'Recommended CPE Credit(s):' }, { ul: buildHourList(event.hours) }] }
              ]
            }
          ]
        },
        {
          margin: [40, 10, 40, 0],
          fontSize: 9,
          text:
            '*To allow for proper CPE credit calculation, please note time of late arrival, early departure, and/or any time missing from the classroom per day (start and end time) in the Participant Exception Details column.',
          alignment: 'center'
        },
        {
          margin: [20, 20, 20, 0],
          table: {
            dontBreakRows: true,
            widths: [150, 185, 150, 200],
            headerRows: 2,
            height: 12,
            body: [
              [
                { text: 'Name', style: 'tableHeader' },
                {
                  stack: [
                    { text: 'Email', style: 'tableHeader' },
                    { text: '( Where certificates will be sent )', style: 'thirdHeader' }
                  ],
                  fillColor: '#eeeeee'
                },
                { text: 'Signature', style: 'tableHeader' },
                { text: 'Participant Exception Details *', style: 'tableHeader' }
              ],
              [{ text: 'Participants', bold: true, colSpan: 4, fillColor: '#eeeeee' }, {}, {}, {}],
              ...buildRegistrants(registrants, blank),
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}]
            ]
          }
        }
      ],
      styles: {
        tableHeader: { alignment: 'center', fontSize: 14, bold: true },
        secondaryHeader: { alignment: 'center', fontSize: 13, bold: true },
        thirdHeader: { alignment: 'center', fontSize: 8, bold: true },
        tableContent: { fontSize: 9 }
      }
    };
  }

  function inOutDoc(event, registrants, blank) {
    return {
      pageSize: 'LETTER',
      pageOrientation: 'landscape',
      pageMargins: [10, 30, 10, 40],
      footer: (currentPage, pageCount) => {
        return {
          margin: [20, 0, 20, 0],
          layout: 'noBorders',
          table: {
            widths: ['auto', 'auto', '*', 'auto'],
            body: [
              [
                { text: `Program Title:\n${event.course_name}`, fontSize: 8 },
                { text: `Date:\n${getDate(event.delivery_date, vm.location.timeZoneId)}`, fontSize: 8 },
                { text: `Location:\n${vm.location.location || 'Remote'}`, fontSize: 8 },
                { alignment: 'right', text: `Page ${currentPage} of ${pageCount}`, fontSize: 8 }
              ]
            ]
          }
        };
      },
      content: [
        {
          margin: [30, 20, 30, 0],
          stack: [
            {
              columns: [
                {
                  stack: [
                    { text: `Program Title: ${event.course_name}` },
                    { text: `Location: ${vm.location.location || 'Remote'}` },
                    { text: `Start Date: ${getDate(event.delivery_date, vm.location.timeZoneId) || 'NA'}` },
                    { text: `End Date: ${getDate(event.delivery_end_date, vm.location.timeZoneId) || 'NA'}` }
                  ]
                },
                sponsorLogo()
              ]
            }
          ]
        },
        {
          margin: [30, 10, 30, 0],
          stack: [
            {
              columns: [
                { stack: [{ text: 'Instructor(s):' }, { ul: buildInstructorList(event.instructors) }] },
                { stack: [{ text: 'Recommended CPE Credit(s):' }, { ul: buildHourList(event.hours) }] }
              ]
            }
          ]
        },
        {
          pageBreak: 'after',
          margin: [20, 20, 20, 0],
          table: {
            dontBreakRows: true,
            widths: [125, 150, 50, 40, 70, 100, '*', '*'],
            headerRows: 2,
            height: 12,
            body: [
              [
                { text: 'Name', style: 'tableHeader' },
                {
                  stack: [
                    { text: 'Email', style: 'tableHeader' },
                    { text: '( Where certificates will be sent )', style: 'thirdHeader' }
                  ]
                },
                {
                  stack: [
                    { text: 'Taught Before?', style: 'secondaryHeader' },
                    { text: '( Y / N )', style: 'thirdHeader' }
                  ]
                },
                {
                  stack: [{ text: 'Prep', style: 'tableHeader' }, { text: '( Minutes )', style: 'thirdHeader' }]
                },
                {
                  stack: [{ text: 'Instruction', style: 'tableHeader' }, { text: '( Minutes )', style: 'thirdHeader' }]
                },
                { text: 'Signature', style: 'tableHeader' },
                { text: 'Time-In', style: 'tableHeader' },
                { text: 'Time-Out', style: 'tableHeader' }
              ],
              [
                {
                  text: 'Instructors',
                  bold: true,
                  colSpan: 8,
                  fillColor: '#eeeeee'
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
              ],
              ...buildInstructors(event.instructors, blank, 'signInOut'),
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}]
            ]
          }
        },
        {
          margin: [30, 20, 30, 0],
          stack: [
            {
              columns: [
                {
                  stack: [
                    { text: `Program Title: ${event.course_name}` },
                    { text: `Location: ${vm.location.location || 'Remote'}` },
                    { text: `Start Date: ${getDate(event.delivery_date, vm.location.timeZoneId) || 'NA'}` },
                    { text: `End Date: ${getDate(event.delivery_end_date, vm.location.timeZoneId) || 'NA'}` }
                  ]
                },
                sponsorLogo()
              ]
            }
          ]
        },
        {
          margin: [30, 10, 30, 0],
          stack: [
            {
              columns: [
                { stack: [{ text: 'Instructor(s):' }, { ul: buildInstructorList(event.instructors) }] },
                { stack: [{ text: 'Recommended CPE Credit(s):' }, { ul: buildHourList(event.hours) }] }
              ]
            }
          ]
        },
        {
          margin: [20, 20, 20, 0],
          table: {
            dontBreakRows: true,
            widths: [125, 250, 170, 70, 70],
            headerRows: 2,
            height: 12,
            body: [
              [
                { text: 'Name', style: 'tableHeader' },
                {
                  stack: [
                    { text: 'Email', style: 'tableHeader' },
                    { text: '( Where certificates will be sent )', style: 'thirdHeader' }
                  ]
                },
                { text: 'Signature', style: 'tableHeader' },
                { text: 'Time-In', style: 'tableHeader' },
                { text: 'Time-Out', style: 'tableHeader' }
              ],
              [{ text: 'Participants', bold: true, colSpan: 5, fillColor: '#eeeeee' }, {}, {}, {}, {}],
              ...buildRegistrants(registrants, blank, 'inOut'),
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}]
            ]
          }
        }
      ],
      styles: {
        tableHeader: { alignment: 'center', fontSize: 14, bold: true },
        secondaryHeader: { alignment: 'center', fontSize: 13, bold: true },
        thirdHeader: { alignment: 'center', fontSize: 8, bold: true },
        tableContent: { fontSize: 9 }
      }
    };
  }

  function signInOutDoc(event, registrants, blank) {
    return {
      pageSize: 'LETTER',
      pageOrientation: 'landscape',
      pageMargins: [10, 30, 10, 40],
      footer: (currentPage, pageCount) => {
        return {
          margin: [20, 0, 20, 0],
          layout: 'noBorders',
          table: {
            widths: ['auto', 'auto', '*', 'auto'],
            body: [
              [
                { text: `Program Title:\n${event.course_name}`, fontSize: 8 },
                { text: `Date:\n${getDate(event.delivery_date, vm.location.timeZoneId)}`, fontSize: 8 },
                { text: `Location:\n${vm.location.location || 'Remote'}`, fontSize: 8 },
                { alignment: 'right', text: `Page ${currentPage} of ${pageCount}`, fontSize: 8 }
              ]
            ]
          }
        };
      },
      content: [
        {
          margin: [30, 20, 30, 0],
          stack: [
            {
              columns: [
                {
                  stack: [
                    { text: `Program Title: ${event.course_name}` },
                    { text: `Location: ${vm.location.location || 'Remote'}` },
                    { text: `Start Date: ${getDate(event.delivery_date, vm.location.timeZoneId) || 'NA'}` },
                    { text: `End Date: ${getDate(event.delivery_end_date, vm.location.timeZoneId) || 'NA'}` }
                  ]
                },
                sponsorLogo()
              ]
            }
          ]
        },
        {
          margin: [30, 10, 30, 0],
          stack: [
            {
              columns: [
                { stack: [{ text: 'Instructor(s):' }, { ul: buildInstructorList(event.instructors) }] },
                { stack: [{ text: 'Recommended CPE Credit(s):' }, { ul: buildHourList(event.hours) }] }
              ]
            }
          ]
        },
        {
          pageBreak: 'after',
          margin: [20, 20, 20, 0],
          table: {
            dontBreakRows: true,
            widths: [125, 160, 50, 40, '*', 65, '*', 65],
            headerRows: 2,
            height: 12,
            body: [
              [
                { text: 'Name', style: 'tableHeader' },
                {
                  stack: [
                    { text: 'Email', style: 'tableHeader' },
                    { text: '( Where certificates will be sent )', style: 'thirdHeader' }
                  ]
                },
                {
                  stack: [
                    { text: 'Taught Before?', style: 'secondaryHeader' },
                    { text: '( Y / N )', style: 'thirdHeader' }
                  ]
                },
                {
                  stack: [{ text: 'Prep', style: 'tableHeader' }, { text: '( Minutes )', style: 'thirdHeader' }]
                },
                { text: 'Signature', style: 'tableHeader' },
                {
                  stack: [{ text: 'Arrival', style: 'tableHeader' }, { text: '( Time )', style: 'thirdHeader' }]
                },
                { text: 'Signature', style: 'tableHeader' },
                {
                  stack: [{ text: 'Departure', style: 'tableHeader' }, { text: '( Time )', style: 'thirdHeader' }]
                }
              ],
              [
                {
                  text: 'Instructors',
                  bold: true,
                  colSpan: 8,
                  fillColor: '#eeeeee'
                },
                {},
                {},
                {},
                {},
                {},
                {},
                {}
              ],
              ...buildInstructors(event.instructors, blank, 'signInOut'),
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}],
              [{}, { fillColor: '#eeeeee', text: ' ' }, {}, {}, {}, {}, {}, {}]
            ]
          }
        },
        {
          margin: [30, 20, 30, 0],
          stack: [
            {
              columns: [
                {
                  stack: [
                    { text: `Program Title: ${event.course_name}` },
                    { text: `Location: ${vm.location.location || 'Remote'}` },
                    { text: `Start Date: ${getDate(event.delivery_date, vm.location.timeZoneId) || 'NA'}` },
                    { text: `End Date: ${getDate(event.delivery_end_date, vm.location.timeZoneId) || 'NA'}` }
                  ]
                },
                sponsorLogo()
              ]
            }
          ]
        },
        {
          margin: [30, 10, 30, 0],
          stack: [
            {
              columns: [
                { stack: [{ text: 'Instructor(s):' }, { ul: buildInstructorList(event.instructors) }] },
                { stack: [{ text: 'Recommended CPE Credit(s):' }, { ul: buildHourList(event.hours) }] }
              ]
            }
          ]
        },
        {
          margin: [40, 10, 40, 0],
          fontSize: 9,
          text:
            '*To allow for proper CPE credit calculation, please note time of late arrival, early departure, and/or any time missing from the classroom per day (start and end time) in the Participant Exception Details column.',
          alignment: 'center'
        },
        {
          margin: [20, 20, 20, 0],
          table: {
            dontBreakRows: true,
            widths: [125, 220, 100, 70, 100, 70],
            headerRows: 2,
            height: 12,
            body: [
              [
                { text: 'Name', style: 'tableHeader' },
                {
                  stack: [
                    { text: 'Email', style: 'tableHeader' },
                    { text: '( Where certificates will be sent )', style: 'thirdHeader' }
                  ]
                },
                { text: 'Signature', style: 'tableHeader' },
                {
                  stack: [{ text: 'Arrival', style: 'tableHeader' }, { text: '( Time )', style: 'thirdHeader' }]
                },
                { text: 'Signature', style: 'tableHeader' },
                {
                  stack: [{ text: 'Departure', style: 'tableHeader' }, { text: '( Time )', style: 'thirdHeader' }]
                }
              ],
              [{ text: 'Participants', bold: true, colSpan: 6, fillColor: '#eeeeee' }, {}, {}, {}, {}, {}],
              ...buildRegistrants(registrants, blank, 'signInOut'),
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}],
              [{}, { text: ' ', fillColor: '#eeeeee' }, {}, {}, {}, {}]
            ]
          }
        }
      ],
      styles: {
        tableHeader: { alignment: 'center', fontSize: 14, bold: true },
        secondaryHeader: { alignment: 'center', fontSize: 13, bold: true },
        thirdHeader: { alignment: 'center', fontSize: 8, bold: true },
        tableContent: { fontSize: 9 }
      }
    };
  }

  vm.generateSignInSheet = (blank = false, type, action) => {
    const reports = {
      inOut: () => inOutDoc(vm.event, vm.eventRegistrants, blank),
      signInOut: () => signInOutDoc(vm.event, vm.eventRegistrants, blank),
      simple: () => simpleSignInSheetDoc(vm.event, vm.eventRegistrants, blank)
    };

    if (type in reports === false) throw new Error('Report type does not exist');

    const docDefinition = reports[type]();

    const report = pdfMake.createPdf(docDefinition);

    if (action === 'download') report.download('index.pdf');
    else report.open();
  };

  function activate() {
    if (!vm.event.sponsor) return;
    const sponsor = vm.event.sponsor;
    if (!sponsor.logoUrl) return;
    urlToDataUrl(sponsor.logoUrl)
      .then(url => (sponsorLogoUrl = url))
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/signInSheet/controller.js